(() => {
    var e = {
            5858: (e, t, n) => {
                var r = "Expected a function",
                    o = NaN,
                    i = "[object Symbol]",
                    u = /^\s+|\s+$/g,
                    l = /^[-+]0x[0-9a-f]+$/i,
                    c = /^0b[01]+$/i,
                    a = /^0o[0-7]+$/i,
                    s = parseInt,
                    _ = "object" == typeof n.g && n.g && n.g.Object === Object && n.g,
                    f = "object" == typeof self && self && self.Object === Object && self,
                    d = _ || f || Function("return this")(),
                    v = Object.prototype.toString,
                    p = Math.max,
                    h = Math.min,
                    m = function () {
                        return d.Date.now();
                    };
                function y(e, t, n) {
                    var o,
                        i,
                        u,
                        l,
                        c,
                        a,
                        s = 0,
                        _ = !1,
                        f = !1,
                        d = !0;
                    if ("function" != typeof e) throw new TypeError(r);
                    function v(t) {
                        var n = o,
                            r = i;
                        return (o = i = void 0), (s = t), (l = e.apply(r, n));
                    }
                    function y(e) {
                        var n = e - a;
                        return void 0 === a || n >= t || n < 0 || (f && e - s >= u);
                    }
                    function w() {
                        var e = m();
                        if (y(e)) return x(e);
                        c = setTimeout(
                            w,
                            (function (e) {
                                var n = t - (e - a);
                                return f ? h(n, u - (e - s)) : n;
                            })(e)
                        );
                    }
                    function x(e) {
                        return (c = void 0), d && o ? v(e) : ((o = i = void 0), l);
                    }
                    function k() {
                        var e = m(),
                            n = y(e);
                        if (((o = arguments), (i = this), (a = e), n)) {
                            if (void 0 === c)
                                return (function (e) {
                                    return (s = e), (c = setTimeout(w, t)), _ ? v(e) : l;
                                })(a);
                            if (f) return (c = setTimeout(w, t)), v(a);
                        }
                        return void 0 === c && (c = setTimeout(w, t)), l;
                    }
                    return (
                        (t = b(t) || 0),
                        g(n) && ((_ = !!n.leading), (u = (f = "maxWait" in n) ? p(b(n.maxWait) || 0, t) : u), (d = "trailing" in n ? !!n.trailing : d)),
                        (k.cancel = function () {
                            void 0 !== c && clearTimeout(c), (s = 0), (o = a = i = c = void 0);
                        }),
                        (k.flush = function () {
                            return void 0 === c ? l : x(m());
                        }),
                        k
                    );
                }
                function g(e) {
                    var t = typeof e;
                    return !!e && ("object" == t || "function" == t);
                }
                function b(e) {
                    if ("number" == typeof e) return e;
                    if (
                        (function (e) {
                            return (
                                "symbol" == typeof e ||
                                ((function (e) {
                                    return !!e && "object" == typeof e;
                                })(e) &&
                                    v.call(e) == i)
                            );
                        })(e)
                    )
                        return o;
                    if (g(e)) {
                        var t = "function" == typeof e.valueOf ? e.valueOf() : e;
                        e = g(t) ? t + "" : t;
                    }
                    if ("string" != typeof e) return 0 === e ? e : +e;
                    e = e.replace(u, "");
                    var n = c.test(e);
                    return n || a.test(e) ? s(e.slice(2), n ? 2 : 8) : l.test(e) ? o : +e;
                }
                e.exports = function (e, t, n) {
                    var o = !0,
                        i = !0;
                    if ("function" != typeof e) throw new TypeError(r);
                    return g(n) && ((o = "leading" in n ? !!n.leading : o), (i = "trailing" in n ? !!n.trailing : i)), y(e, t, { leading: o, maxWait: t, trailing: i });
                };
            },
            171: () => {},
            5072: (e) => {
                "use strict";
                var t = [];
                function n(e) {
                    for (var n = -1, r = 0; r < t.length; r++)
                        if (t[r].identifier === e) {
                            n = r;
                            break;
                        }
                    return n;
                }
                function r(e, r) {
                    for (var i = {}, u = [], l = 0; l < e.length; l++) {
                        var c = e[l],
                            a = r.base ? c[0] + r.base : c[0],
                            s = i[a] || 0,
                            _ = "".concat(a, " ").concat(s);
                        i[a] = s + 1;
                        var f = n(_),
                            d = { css: c[1], media: c[2], sourceMap: c[3], supports: c[4], layer: c[5] };
                        if (-1 !== f) t[f].references++, t[f].updater(d);
                        else {
                            var v = o(d, r);
                            (r.byIndex = l), t.splice(l, 0, { identifier: _, updater: v, references: 1 });
                        }
                        u.push(_);
                    }
                    return u;
                }
                function o(e, t) {
                    var n = t.domAPI(t);
                    n.update(e);
                    return function (t) {
                        if (t) {
                            if (t.css === e.css && t.media === e.media && t.sourceMap === e.sourceMap && t.supports === e.supports && t.layer === e.layer) return;
                            n.update((e = t));
                        } else n.remove();
                    };
                }
                e.exports = function (e, o) {
                    var i = r((e = e || []), (o = o || {}));
                    return function (e) {
                        e = e || [];
                        for (var u = 0; u < i.length; u++) {
                            var l = n(i[u]);
                            t[l].references--;
                        }
                        for (var c = r(e, o), a = 0; a < i.length; a++) {
                            var s = n(i[a]);
                            0 === t[s].references && (t[s].updater(), t.splice(s, 1));
                        }
                        i = c;
                    };
                };
            },
            7659: (e) => {
                "use strict";
                var t = {};
                e.exports = function (e, n) {
                    var r = (function (e) {
                        if (void 0 === t[e]) {
                            var n = document.querySelector(e);
                            if (window.HTMLIFrameElement && n instanceof window.HTMLIFrameElement)
                                try {
                                    n = n.contentDocument.head;
                                } catch (e) {
                                    n = null;
                                }
                            t[e] = n;
                        }
                        return t[e];
                    })(e);
                    if (!r) throw new Error("Couldn't find a style target. This probably means that the value for the 'insert' parameter is invalid.");
                    r.appendChild(n);
                };
            },
            540: (e) => {
                "use strict";
                e.exports = function (e) {
                    var t = document.createElement("style");
                    return e.setAttributes(t, e.attributes), e.insert(t, e.options), t;
                };
            },
            5056: (e, t, n) => {
                "use strict";
                e.exports = function (e) {
                    var t = n.nc;
                    t && e.setAttribute("nonce", t);
                };
            },
            7825: (e) => {
                "use strict";
                e.exports = function (e) {
                    if ("undefined" == typeof document) return { update: function () {}, remove: function () {} };
                    var t = e.insertStyleElement(e);
                    return {
                        update: function (n) {
                            !(function (e, t, n) {
                                var r = "";
                                n.supports && (r += "@supports (".concat(n.supports, ") {")), n.media && (r += "@media ".concat(n.media, " {"));
                                var o = void 0 !== n.layer;
                                o && (r += "@layer".concat(n.layer.length > 0 ? " ".concat(n.layer) : "", " {")), (r += n.css), o && (r += "}"), n.media && (r += "}"), n.supports && (r += "}");
                                var i = n.sourceMap;
                                i && "undefined" != typeof btoa && (r += "\n/*# sourceMappingURL=data:application/json;base64,".concat(btoa(unescape(encodeURIComponent(JSON.stringify(i)))), " */")), t.styleTagTransform(r, e, t.options);
                            })(t, e, n);
                        },
                        remove: function () {
                            !(function (e) {
                                if (null === e.parentNode) return !1;
                                e.parentNode.removeChild(e);
                            })(t);
                        },
                    };
                };
            },
            1113: (e) => {
                "use strict";
                e.exports = function (e, t) {
                    if (t.styleSheet) t.styleSheet.cssText = e;
                    else {
                        for (; t.firstChild; ) t.removeChild(t.firstChild);
                        t.appendChild(document.createTextNode(e));
                    }
                };
            },
        },
        t = {};
    function n(r) {
        var o = t[r];
        if (void 0 !== o) return o.exports;
        var i = (t[r] = { exports: {} });
        return e[r](i, i.exports, n), i.exports;
    }
    (n.n = (e) => {
        var t = e && e.__esModule ? () => e.default : () => e;
        return n.d(t, { a: t }), t;
    }),
        (n.d = (e, t) => {
            for (var r in t) n.o(t, r) && !n.o(e, r) && Object.defineProperty(e, r, { enumerable: !0, get: t[r] });
        }),
        (n.g = (function () {
            if ("object" == typeof globalThis) return globalThis;
            try {
                return this || new Function("return this")();
            } catch (e) {
                if ("object" == typeof window) return window;
            }
        })()),
        (n.o = (e, t) => Object.prototype.hasOwnProperty.call(e, t)),
        (n.nc = void 0),
        (() => {
            "use strict";
            function e(e, t) {
                (null == t || t > e.length) && (t = e.length);
                for (var n = 0, r = Array(t); n < t; n++) r[n] = e[n];
                return r;
            }
            function t(t, n) {
                if (t) {
                    if ("string" == typeof t) return e(t, n);
                    var r = {}.toString.call(t).slice(8, -1);
                    return "Object" === r && t.constructor && (r = t.constructor.name), "Map" === r || "Set" === r ? Array.from(t) : "Arguments" === r || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(r) ? e(t, n) : void 0;
                }
            }
            function r(n) {
                return (
                    (function (t) {
                        if (Array.isArray(t)) return e(t);
                    })(n) ||
                    (function (e) {
                        if (("undefined" != typeof Symbol && null != e[Symbol.iterator]) || null != e["@@iterator"]) return Array.from(e);
                    })(n) ||
                    t(n) ||
                    (function () {
                        throw new TypeError("Invalid attempt to spread non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
                    })()
                );
            }
            function o(e) {
                return (
                    (o =
                        "function" == typeof Symbol && "symbol" == typeof Symbol.iterator
                            ? function (e) {
                                  return typeof e;
                              }
                            : function (e) {
                                  return e && "function" == typeof Symbol && e.constructor === Symbol && e !== Symbol.prototype ? "symbol" : typeof e;
                              }),
                    o(e)
                );
            }
            function i(e) {
                var t = (function (e, t) {
                    if ("object" != o(e) || !e) return e;
                    var n = e[Symbol.toPrimitive];
                    if (void 0 !== n) {
                        var r = n.call(e, t || "default");
                        if ("object" != o(r)) return r;
                        throw new TypeError("@@toPrimitive must return a primitive value.");
                    }
                    return ("string" === t ? String : Number)(e);
                })(e, "string");
                return "symbol" == o(t) ? t : t + "";
            }
            function u(e, t, n) {
                return (t = i(t)) in e ? Object.defineProperty(e, t, { value: n, enumerable: !0, configurable: !0, writable: !0 }) : (e[t] = n), e;
            }
            function l(e, n) {
                return (
                    (function (e) {
                        if (Array.isArray(e)) return e;
                    })(e) ||
                    (function (e, t) {
                        var n = null == e ? null : ("undefined" != typeof Symbol && e[Symbol.iterator]) || e["@@iterator"];
                        if (null != n) {
                            var r,
                                o,
                                i,
                                u,
                                l = [],
                                c = !0,
                                a = !1;
                            try {
                                if (((i = (n = n.call(e)).next), 0 === t)) {
                                    if (Object(n) !== n) return;
                                    c = !1;
                                } else for (; !(c = (r = i.call(n)).done) && (l.push(r.value), l.length !== t); c = !0);
                            } catch (e) {
                                (a = !0), (o = e);
                            } finally {
                                try {
                                    if (!c && null != n.return && ((u = n.return()), Object(u) !== u)) return;
                                } finally {
                                    if (a) throw o;
                                }
                            }
                            return l;
                        }
                    })(e, n) ||
                    t(e, n) ||
                    (function () {
                        throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
                    })()
                );
            }
            var c,
                a,
                s,
                _,
                f,
                d,
                v,
                p,
                h,
                m,
                y = {},
                g = [],
                b = /acit|ex(?:s|g|n|p|$)|rph|grid|ows|mnc|ntw|ine[ch]|zoo|^ord|itera/i,
                w = Array.isArray;
            function x(e, t) {
                for (var n in t) e[n] = t[n];
                return e;
            }
            function k(e) {
                var t = e.parentNode;
                t && t.removeChild(e);
            }
            function N(e, t, n) {
                var r,
                    o,
                    i,
                    u = {};
                for (i in t) "key" == i ? (r = t[i]) : "ref" == i ? (o = t[i]) : (u[i] = t[i]);
                if ((arguments.length > 2 && (u.children = arguments.length > 3 ? c.call(arguments, 2) : n), "function" == typeof e && null != e.defaultProps)) for (i in e.defaultProps) void 0 === u[i] && (u[i] = e.defaultProps[i]);
                return C(e, u, r, o, null);
            }
            function C(e, t, n, r, o) {
                var i = { type: e, props: t, key: n, ref: r, __k: null, __: null, __b: 0, __e: null, __d: void 0, __c: null, constructor: void 0, __v: null == o ? ++s : o, __i: -1, __u: 0 };
                return null == o && null != a.vnode && a.vnode(i), i;
            }
            function T(e) {
                return e.children;
            }
            function E(e, t) {
                (this.props = e), (this.context = t);
            }
            function S(e, t) {
                if (null == t) return e.__ ? S(e.__, e.__i + 1) : null;
                for (var n; t < e.__k.length; t++) if (null != (n = e.__k[t]) && null != n.__e) return n.__e;
                return "function" == typeof e.type ? S(e) : null;
            }
            function A(e) {
                var t, n;
                if (null != (e = e.__) && null != e.__c) {
                    for (e.__e = e.__c.base = null, t = 0; t < e.__k.length; t++)
                        if (null != (n = e.__k[t]) && null != n.__e) {
                            e.__e = e.__c.base = n.__e;
                            break;
                        }
                    return A(e);
                }
            }
            function P(e) {
                ((!e.__d && (e.__d = !0) && _.push(e) && !j.__r++) || f !== a.debounceRendering) && ((f = a.debounceRendering) || d)(j);
            }
            function j() {
                var e, t, n, r, o, i, u, l;
                for (_.sort(v); (e = _.shift()); )
                    e.__d &&
                        ((t = _.length),
                        (r = void 0),
                        (i = (o = (n = e).__v).__e),
                        (u = []),
                        (l = []),
                        n.__P &&
                            (((r = x({}, o)).__v = o.__v + 1),
                            a.vnode && a.vnode(r),
                            F(n.__P, r, o, n.__n, n.__P.namespaceURI, 32 & o.__u ? [i] : null, u, null == i ? S(o) : i, !!(32 & o.__u), l),
                            (r.__v = o.__v),
                            (r.__.__k[r.__i] = r),
                            W(u, r, l),
                            r.__e != i && A(r)),
                        _.length > t && _.sort(v));
                j.__r = 0;
            }
            function M(e, t, n, r, o, i, u, l, c, a, s) {
                var _,
                    f,
                    d,
                    v,
                    p,
                    h = (r && r.__k) || g,
                    m = t.length;
                for (n.__d = c, O(n, t, h), c = n.__d, _ = 0; _ < m; _++)
                    null != (d = n.__k[_]) &&
                        "boolean" != typeof d &&
                        "function" != typeof d &&
                        ((f = -1 === d.__i ? y : h[d.__i] || y),
                        (d.__i = _),
                        F(e, d, f, o, i, u, l, c, a, s),
                        (v = d.__e),
                        d.ref && f.ref != d.ref && (f.ref && R(f.ref, null, d), s.push(d.ref, d.__c || v, d)),
                        null == p && null != v && (p = v),
                        65536 & d.__u || f.__k === d.__k ? (c && !c.isConnected && (c = S(f)), (c = L(d, c, e))) : "function" == typeof d.type && void 0 !== d.__d ? (c = d.__d) : v && (c = v.nextSibling),
                        (d.__d = void 0),
                        (d.__u &= -196609));
                (n.__d = c), (n.__e = p);
            }
            function O(e, t, n) {
                var r,
                    o,
                    i,
                    u,
                    l,
                    c = t.length,
                    a = n.length,
                    s = a,
                    _ = 0;
                for (e.__k = [], r = 0; r < c; r++)
                    (u = r + _),
                        null !=
                        (o = e.__k[r] =
                            null == (o = t[r]) || "boolean" == typeof o || "function" == typeof o
                                ? null
                                : "string" == typeof o || "number" == typeof o || "bigint" == typeof o || o.constructor == String
                                ? C(null, o, null, null, null)
                                : w(o)
                                ? C(T, { children: o }, null, null, null)
                                : void 0 === o.constructor && o.__b > 0
                                ? C(o.type, o.props, o.key, o.ref ? o.ref : null, o.__v)
                                : o)
                            ? ((o.__ = e),
                              (o.__b = e.__b + 1),
                              (l = D(o, n, u, s)),
                              (o.__i = l),
                              (i = null),
                              -1 !== l && (s--, (i = n[l]) && (i.__u |= 131072)),
                              null == i || null === i.__v
                                  ? (-1 == l && _--, "function" != typeof o.type && (o.__u |= 65536))
                                  : l !== u && (l === u + 1 ? _++ : l > u ? (s > c - u ? (_ += l - u) : _--) : l < u ? l == u - 1 && (_ = l - u) : (_ = 0), l !== r + _ && (o.__u |= 65536)))
                            : (i = n[u]) && null == i.key && i.__e && !(131072 & i.__u) && (i.__e == e.__d && (e.__d = S(i)), $(i, i, !1), (n[u] = null), s--);
                if (s) for (r = 0; r < a; r++) null != (i = n[r]) && !(131072 & i.__u) && (i.__e == e.__d && (e.__d = S(i)), $(i, i));
            }
            function L(e, t, n) {
                var r, o;
                if ("function" == typeof e.type) {
                    for (r = e.__k, o = 0; r && o < r.length; o++) r[o] && ((r[o].__ = e), (t = L(r[o], t, n)));
                    return t;
                }
                e.__e != t && (n.insertBefore(e.__e, t || null), (t = e.__e));
                do {
                    t = t && t.nextSibling;
                } while (null != t && 8 === t.nodeType);
                return t;
            }
            function D(e, t, n, r) {
                var o = e.key,
                    i = e.type,
                    u = n - 1,
                    l = n + 1,
                    c = t[n];
                if (null === c || (c && o == c.key && i === c.type && !(131072 & c.__u))) return n;
                if (r > (null == c || 131072 & c.__u ? 0 : 1))
                    for (; u >= 0 || l < t.length; ) {
                        if (u >= 0) {
                            if ((c = t[u]) && !(131072 & c.__u) && o == c.key && i === c.type) return u;
                            u--;
                        }
                        if (l < t.length) {
                            if ((c = t[l]) && !(131072 & c.__u) && o == c.key && i === c.type) return l;
                            l++;
                        }
                    }
                return -1;
            }
            function H(e, t, n) {
                "-" === t[0] ? e.setProperty(t, null == n ? "" : n) : (e[t] = null == n ? "" : "number" != typeof n || b.test(t) ? n : n + "px");
            }
            function I(e, t, n, r, o) {
                var i;
                e: if ("style" === t)
                    if ("string" == typeof n) e.style.cssText = n;
                    else {
                        if (("string" == typeof r && (e.style.cssText = r = ""), r)) for (t in r) (n && t in n) || H(e.style, t, "");
                        if (n) for (t in n) (r && n[t] === r[t]) || H(e.style, t, n[t]);
                    }
                else if ("o" === t[0] && "n" === t[1])
                    (i = t !== (t = t.replace(/(PointerCapture)$|Capture$/i, "$1"))),
                        (t = t.toLowerCase() in e || "onFocusOut" === t || "onFocusIn" === t ? t.toLowerCase().slice(2) : t.slice(2)),
                        e.l || (e.l = {}),
                        (e.l[t + i] = n),
                        n ? (r ? (n.u = r.u) : ((n.u = p), e.addEventListener(t, i ? m : h, i))) : e.removeEventListener(t, i ? m : h, i);
                else {
                    if ("http://www.w3.org/2000/svg" == o) t = t.replace(/xlink(H|:h)/, "h").replace(/sName$/, "s");
                    else if ("width" != t && "height" != t && "href" != t && "list" != t && "form" != t && "tabIndex" != t && "download" != t && "rowSpan" != t && "colSpan" != t && "role" != t && t in e)
                        try {
                            e[t] = null == n ? "" : n;
                            break e;
                        } catch (e) {}
                    "function" == typeof n || (null == n || (!1 === n && "-" !== t[4]) ? e.removeAttribute(t) : e.setAttribute(t, n));
                }
            }
            function U(e) {
                return function (t) {
                    if (this.l) {
                        var n = this.l[t.type + e];
                        if (null == t.t) t.t = p++;
                        else if (t.t < n.u) return;
                        return n(a.event ? a.event(t) : t);
                    }
                };
            }
            function F(e, t, n, r, o, i, u, l, c, s) {
                var _,
                    f,
                    d,
                    v,
                    p,
                    h,
                    m,
                    y,
                    g,
                    b,
                    k,
                    N,
                    C,
                    S,
                    A,
                    P = t.type;
                if (void 0 !== t.constructor) return null;
                128 & n.__u && ((c = !!(32 & n.__u)), (i = [(l = t.__e = n.__e)])), (_ = a.__b) && _(t);
                e: if ("function" == typeof P)
                    try {
                        if (
                            ((y = t.props),
                            (g = (_ = P.contextType) && r[_.__c]),
                            (b = _ ? (g ? g.props.value : _.__) : r),
                            n.__c
                                ? (m = (f = t.__c = n.__c).__ = f.__E)
                                : ("prototype" in P && P.prototype.render ? (t.__c = f = new P(y, b)) : ((t.__c = f = new E(y, b)), (f.constructor = P), (f.render = V)),
                                  g && g.sub(f),
                                  (f.props = y),
                                  f.state || (f.state = {}),
                                  (f.context = b),
                                  (f.__n = r),
                                  (d = f.__d = !0),
                                  (f.__h = []),
                                  (f._sb = [])),
                            null == f.__s && (f.__s = f.state),
                            null != P.getDerivedStateFromProps && (f.__s == f.state && (f.__s = x({}, f.__s)), x(f.__s, P.getDerivedStateFromProps(y, f.__s))),
                            (v = f.props),
                            (p = f.state),
                            (f.__v = t),
                            d)
                        )
                            null == P.getDerivedStateFromProps && null != f.componentWillMount && f.componentWillMount(), null != f.componentDidMount && f.__h.push(f.componentDidMount);
                        else {
                            if (
                                (null == P.getDerivedStateFromProps && y !== v && null != f.componentWillReceiveProps && f.componentWillReceiveProps(y, b),
                                !f.__e && ((null != f.shouldComponentUpdate && !1 === f.shouldComponentUpdate(y, f.__s, b)) || t.__v === n.__v))
                            ) {
                                for (
                                    t.__v !== n.__v && ((f.props = y), (f.state = f.__s), (f.__d = !1)),
                                        t.__e = n.__e,
                                        t.__k = n.__k,
                                        t.__k.forEach(function (e) {
                                            e && (e.__ = t);
                                        }),
                                        k = 0;
                                    k < f._sb.length;
                                    k++
                                )
                                    f.__h.push(f._sb[k]);
                                (f._sb = []), f.__h.length && u.push(f);
                                break e;
                            }
                            null != f.componentWillUpdate && f.componentWillUpdate(y, f.__s, b),
                                null != f.componentDidUpdate &&
                                    f.__h.push(function () {
                                        f.componentDidUpdate(v, p, h);
                                    });
                        }
                        if (((f.context = b), (f.props = y), (f.__P = e), (f.__e = !1), (N = a.__r), (C = 0), "prototype" in P && P.prototype.render)) {
                            for (f.state = f.__s, f.__d = !1, N && N(t), _ = f.render(f.props, f.state, f.context), S = 0; S < f._sb.length; S++) f.__h.push(f._sb[S]);
                            f._sb = [];
                        } else
                            do {
                                (f.__d = !1), N && N(t), (_ = f.render(f.props, f.state, f.context)), (f.state = f.__s);
                            } while (f.__d && ++C < 25);
                        (f.state = f.__s),
                            null != f.getChildContext && (r = x(x({}, r), f.getChildContext())),
                            d || null == f.getSnapshotBeforeUpdate || (h = f.getSnapshotBeforeUpdate(v, p)),
                            M(e, w((A = null != _ && _.type === T && null == _.key ? _.props.children : _)) ? A : [A], t, n, r, o, i, u, l, c, s),
                            (f.base = t.__e),
                            (t.__u &= -161),
                            f.__h.length && u.push(f),
                            m && (f.__E = f.__ = null);
                    } catch (e) {
                        (t.__v = null), c || null != i ? ((t.__e = l), (t.__u |= c ? 160 : 32), (i[i.indexOf(l)] = null)) : ((t.__e = n.__e), (t.__k = n.__k)), a.__e(e, t, n);
                    }
                else null == i && t.__v === n.__v ? ((t.__k = n.__k), (t.__e = n.__e)) : (t.__e = B(n.__e, t, n, r, o, i, u, c, s));
                (_ = a.diffed) && _(t);
            }
            function W(e, t, n) {
                t.__d = void 0;
                for (var r = 0; r < n.length; r++) R(n[r], n[++r], n[++r]);
                a.__c && a.__c(t, e),
                    e.some(function (t) {
                        try {
                            (e = t.__h),
                                (t.__h = []),
                                e.some(function (e) {
                                    e.call(t);
                                });
                        } catch (e) {
                            a.__e(e, t.__v);
                        }
                    });
            }
            function B(e, t, n, r, o, i, u, l, a) {
                var s,
                    _,
                    f,
                    d,
                    v,
                    p,
                    h,
                    m = n.props,
                    g = t.props,
                    b = t.type;
                if (("svg" === b ? (o = "http://www.w3.org/2000/svg") : "math" === b ? (o = "http://www.w3.org/1998/Math/MathML") : o || (o = "http://www.w3.org/1999/xhtml"), null != i))
                    for (s = 0; s < i.length; s++)
                        if ((v = i[s]) && "setAttribute" in v == !!b && (b ? v.localName === b : 3 === v.nodeType)) {
                            (e = v), (i[s] = null);
                            break;
                        }
                if (null == e) {
                    if (null === b) return document.createTextNode(g);
                    (e = document.createElementNS(o, b, g.is && g)), (i = null), (l = !1);
                }
                if (null === b) m === g || (l && e.data === g) || (e.data = g);
                else {
                    if (((i = i && c.call(e.childNodes)), (m = n.props || y), !l && null != i)) for (m = {}, s = 0; s < e.attributes.length; s++) m[(v = e.attributes[s]).name] = v.value;
                    for (s in m)
                        if (((v = m[s]), "children" == s));
                        else if ("dangerouslySetInnerHTML" == s) f = v;
                        else if ("key" !== s && !(s in g)) {
                            if (("value" == s && "defaultValue" in g) || ("checked" == s && "defaultChecked" in g)) continue;
                            I(e, s, null, v, o);
                        }
                    for (s in g)
                        (v = g[s]),
                            "children" == s ? (d = v) : "dangerouslySetInnerHTML" == s ? (_ = v) : "value" == s ? (p = v) : "checked" == s ? (h = v) : "key" === s || (l && "function" != typeof v) || m[s] === v || I(e, s, v, m[s], o);
                    if (_) l || (f && (_.__html === f.__html || _.__html === e.innerHTML)) || (e.innerHTML = _.__html), (t.__k = []);
                    else if ((f && (e.innerHTML = ""), M(e, w(d) ? d : [d], t, n, r, "foreignObject" === b ? "http://www.w3.org/1999/xhtml" : o, i, u, i ? i[0] : n.__k && S(n, 0), l, a), null != i))
                        for (s = i.length; s--; ) null != i[s] && k(i[s]);
                    l || ((s = "value"), void 0 !== p && (p !== e[s] || ("progress" === b && !p) || ("option" === b && p !== m[s])) && I(e, s, p, m[s], o), (s = "checked"), void 0 !== h && h !== e[s] && I(e, s, h, m[s], o));
                }
                return e;
            }
            function R(e, t, n) {
                try {
                    "function" == typeof e ? e(t) : (e.current = t);
                } catch (e) {
                    a.__e(e, n);
                }
            }
            function $(e, t, n) {
                var r, o;
                if ((a.unmount && a.unmount(e), (r = e.ref) && ((r.current && r.current !== e.__e) || R(r, null, t)), null != (r = e.__c))) {
                    if (r.componentWillUnmount)
                        try {
                            r.componentWillUnmount();
                        } catch (e) {
                            a.__e(e, t);
                        }
                    r.base = r.__P = null;
                }
                if ((r = e.__k)) for (o = 0; o < r.length; o++) r[o] && $(r[o], t, n || "function" != typeof e.type);
                n || null == e.__e || k(e.__e), (e.__c = e.__ = e.__e = e.__d = void 0);
            }
            function V(e, t, n) {
                return this.constructor(e, n);
            }
            function q(e, t, n) {
                var r, o, i, u;
                a.__ && a.__(e, t),
                    (o = (r = "function" == typeof n) ? null : (n && n.__k) || t.__k),
                    (i = []),
                    (u = []),
                    F(t, (e = ((!r && n) || t).__k = N(T, null, [e])), o || y, y, t.namespaceURI, !r && n ? [n] : o ? null : t.firstChild ? c.call(t.childNodes) : null, i, !r && n ? n : o ? o.__e : t.firstChild, r, u),
                    W(i, e, u);
            }
            function z(e, t) {
                q(e, t, z);
            }
            function G(e, t, n) {
                var r,
                    o,
                    i,
                    u,
                    l = x({}, e.props);
                for (i in (e.type && e.type.defaultProps && (u = e.type.defaultProps), t)) "key" == i ? (r = t[i]) : "ref" == i ? (o = t[i]) : (l[i] = void 0 === t[i] && void 0 !== u ? u[i] : t[i]);
                return arguments.length > 2 && (l.children = arguments.length > 3 ? c.call(arguments, 2) : n), C(e.type, l, r || e.key, o || e.ref, null);
            }
            function Y() {
                return (Y = Object.assign
                    ? Object.assign.bind()
                    : function (e) {
                          for (var t = 1; t < arguments.length; t++) {
                              var n = arguments[t];
                              for (var r in n) Object.prototype.hasOwnProperty.call(n, r) && (e[r] = n[r]);
                          }
                          return e;
                      }).apply(this, arguments);
            }
            (c = g.slice),
                (a = {
                    __e: function (e, t, n, r) {
                        for (var o, i, u; (t = t.__); )
                            if ((o = t.__c) && !o.__)
                                try {
                                    if (
                                        ((i = o.constructor) && null != i.getDerivedStateFromError && (o.setState(i.getDerivedStateFromError(e)), (u = o.__d)),
                                        null != o.componentDidCatch && (o.componentDidCatch(e, r || {}), (u = o.__d)),
                                        u)
                                    )
                                        return (o.__E = o);
                                } catch (t) {
                                    e = t;
                                }
                        throw e;
                    },
                }),
                (s = 0),
                (E.prototype.setState = function (e, t) {
                    var n;
                    (n = null != this.__s && this.__s !== this.state ? this.__s : (this.__s = x({}, this.state))),
                        "function" == typeof e && (e = e(x({}, n), this.props)),
                        e && x(n, e),
                        null != e && this.__v && (t && this._sb.push(t), P(this));
                }),
                (E.prototype.forceUpdate = function (e) {
                    this.__v && ((this.__e = !0), e && this.__h.push(e), P(this));
                }),
                (E.prototype.render = T),
                (_ = []),
                (d = "function" == typeof Promise ? Promise.prototype.then.bind(Promise.resolve()) : setTimeout),
                (v = function (e, t) {
                    return e.__v.__b - t.__v.__b;
                }),
                (j.__r = 0),
                (p = 0),
                (h = U(!1)),
                (m = U(!0));
            var J = ["context", "children"];
            function X(e) {
                this.getChildContext = function () {
                    return e.context;
                };
                var t = e.children,
                    n = (function (e, t) {
                        if (null == e) return {};
                        var n,
                            r,
                            o = {},
                            i = Object.keys(e);
                        for (r = 0; r < i.length; r++) t.indexOf((n = i[r])) >= 0 || (o[n] = e[n]);
                        return o;
                    })(e, J);
                return G(t, n);
            }
            function K() {
                var e = new CustomEvent("_preact", { detail: {}, bubbles: !0, cancelable: !0 });
                this.dispatchEvent(e),
                    (this._vdom = N(
                        X,
                        Y({}, this._props, { context: e.detail.context }),
                        (function e(t, n) {
                            if (3 === t.nodeType) return t.data;
                            if (1 !== t.nodeType) return null;
                            var r = [],
                                o = {},
                                i = 0,
                                u = t.attributes,
                                l = t.childNodes;
                            for (i = u.length; i--; ) "slot" !== u[i].name && ((o[u[i].name] = u[i].value), (o[Q(u[i].name)] = u[i].value));
                            for (i = l.length; i--; ) {
                                var c = e(l[i], null),
                                    a = l[i].slot;
                                a ? (o[a] = N(te, { name: a }, c)) : (r[i] = c);
                            }
                            var s = n ? N(te, null, r) : r;
                            return N(n || t.nodeName.toLowerCase(), o, s);
                        })(this, this._vdomComponent)
                    )),
                    (this.hasAttribute("hydrate") ? z : q)(this._vdom, this._root);
            }
            function Q(e) {
                return e.replace(/-(\w)/g, function (e, t) {
                    return t ? t.toUpperCase() : "";
                });
            }
            function Z(e, t, n) {
                if (this._vdom) {
                    var r = {};
                    (r[e] = n = null == n ? void 0 : n), (r[Q(e)] = n), (this._vdom = G(this._vdom, r)), q(this._vdom, this._root);
                }
            }
            function ee() {
                q((this._vdom = null), this._root);
            }
            function te(e, t) {
                var n = this;
                return N(
                    "slot",
                    Y({}, e, {
                        ref: function (e) {
                            e
                                ? ((n.ref = e),
                                  n._listener ||
                                      ((n._listener = function (e) {
                                          e.stopPropagation(), (e.detail.context = t);
                                      }),
                                      e.addEventListener("_preact", n._listener)))
                                : n.ref.removeEventListener("_preact", n._listener);
                        },
                    })
                );
            }
            var ne,
                re,
                oe,
                ie,
                ue = 0,
                le = [],
                ce = [],
                ae = a,
                se = ae.__b,
                _e = ae.__r,
                fe = ae.diffed,
                de = ae.__c,
                ve = ae.unmount,
                pe = ae.__;
            function he(e, t) {
                ae.__h && ae.__h(re, e, ue || t), (ue = 0);
                var n = re.__H || (re.__H = { __: [], __h: [] });
                return e >= n.__.length && n.__.push({ __V: ce }), n.__[e];
            }
            function me(e) {
                return (
                    (ue = 1),
                    (function (e, t, n) {
                        var r = he(ne++, 2);
                        if (
                            ((r.t = e),
                            !r.__c &&
                                ((r.__ = [
                                    n ? n(t) : Ae(void 0, t),
                                    function (e) {
                                        var t = r.__N ? r.__N[0] : r.__[0],
                                            n = r.t(t, e);
                                        t !== n && ((r.__N = [n, r.__[1]]), r.__c.setState({}));
                                    },
                                ]),
                                (r.__c = re),
                                !re.u))
                        ) {
                            var o = function (e, t, n) {
                                if (!r.__c.__H) return !0;
                                var o = r.__c.__H.__.filter(function (e) {
                                    return !!e.__c;
                                });
                                if (
                                    o.every(function (e) {
                                        return !e.__N;
                                    })
                                )
                                    return !i || i.call(this, e, t, n);
                                var u = !1;
                                return (
                                    o.forEach(function (e) {
                                        if (e.__N) {
                                            var t = e.__[0];
                                            (e.__ = e.__N), (e.__N = void 0), t !== e.__[0] && (u = !0);
                                        }
                                    }),
                                    !(!u && r.__c.props === e) && (!i || i.call(this, e, t, n))
                                );
                            };
                            re.u = !0;
                            var i = re.shouldComponentUpdate,
                                u = re.componentWillUpdate;
                            (re.componentWillUpdate = function (e, t, n) {
                                if (this.__e) {
                                    var r = i;
                                    (i = void 0), o(e, t, n), (i = r);
                                }
                                u && u.call(this, e, t, n);
                            }),
                                (re.shouldComponentUpdate = o);
                        }
                        return r.__N || r.__;
                    })(Ae, e)
                );
            }
            function ye(e, t) {
                var n = he(ne++, 3);
                !ae.__s && Se(n.__H, t) && ((n.__ = e), (n.i = t), re.__H.__h.push(n));
            }
            function ge(e) {
                return (
                    (ue = 5),
                    be(function () {
                        return { current: e };
                    }, [])
                );
            }
            function be(e, t) {
                var n = he(ne++, 7);
                return Se(n.__H, t) ? ((n.__V = e()), (n.i = t), (n.__h = e), n.__V) : n.__;
            }
            function we() {
                for (var e; (e = le.shift()); )
                    if (e.__P && e.__H)
                        try {
                            e.__H.__h.forEach(Te), e.__H.__h.forEach(Ee), (e.__H.__h = []);
                        } catch (t) {
                            (e.__H.__h = []), ae.__e(t, e.__v);
                        }
            }
            (ae.__b = function (e) {
                (re = null), se && se(e);
            }),
                (ae.__ = function (e, t) {
                    e && t.__k && t.__k.__m && (e.__m = t.__k.__m), pe && pe(e, t);
                }),
                (ae.__r = function (e) {
                    _e && _e(e), (ne = 0);
                    var t = (re = e.__c).__H;
                    t &&
                        (oe === re
                            ? ((t.__h = []),
                              (re.__h = []),
                              t.__.forEach(function (e) {
                                  e.__N && (e.__ = e.__N), (e.__V = ce), (e.__N = e.i = void 0);
                              }))
                            : (t.__h.forEach(Te), t.__h.forEach(Ee), (t.__h = []), (ne = 0))),
                        (oe = re);
                }),
                (ae.diffed = function (e) {
                    fe && fe(e);
                    var t = e.__c;
                    t &&
                        t.__H &&
                        (t.__H.__h.length && ((1 !== le.push(t) && ie === ae.requestAnimationFrame) || ((ie = ae.requestAnimationFrame) || Ce)(we)),
                        t.__H.__.forEach(function (e) {
                            e.i && (e.__H = e.i), e.__V !== ce && (e.__ = e.__V), (e.i = void 0), (e.__V = ce);
                        })),
                        (oe = re = null);
                }),
                (ae.__c = function (e, t) {
                    t.some(function (e) {
                        try {
                            e.__h.forEach(Te),
                                (e.__h = e.__h.filter(function (e) {
                                    return !e.__ || Ee(e);
                                }));
                        } catch (n) {
                            t.some(function (e) {
                                e.__h && (e.__h = []);
                            }),
                                (t = []),
                                ae.__e(n, e.__v);
                        }
                    }),
                        de && de(e, t);
                }),
                (ae.unmount = function (e) {
                    ve && ve(e);
                    var t,
                        n = e.__c;
                    n &&
                        n.__H &&
                        (n.__H.__.forEach(function (e) {
                            try {
                                Te(e);
                            } catch (e) {
                                t = e;
                            }
                        }),
                        (n.__H = void 0),
                        t && ae.__e(t, n.__v));
                });
            var xe,
                ke,
                Ne = "function" == typeof requestAnimationFrame;
            function Ce(e) {
                var t,
                    n = function () {
                        clearTimeout(r), Ne && cancelAnimationFrame(t), setTimeout(e);
                    },
                    r = setTimeout(n, 100);
                Ne && (t = requestAnimationFrame(n));
            }
            function Te(e) {
                var t = re,
                    n = e.__c;
                "function" == typeof n && ((e.__c = void 0), n()), (re = t);
            }
            function Ee(e) {
                var t = re;
                (e.__c = e.__()), (re = t);
            }
            function Se(e, t) {
                return (
                    !e ||
                    e.length !== t.length ||
                    t.some(function (t, n) {
                        return t !== e[n];
                    })
                );
            }
            function Ae(e, t) {
                return "function" == typeof t ? t(e) : t;
            }
            var Pe = window.GM_STATE,
                je = (null == Pe || null === (xe = Pe.customs) || void 0 === xe || xe.badge.tags, null == Pe || null === (ke = Pe.customs) || void 0 === ke || ke.badge.items, void 0);
            var Me = function e(t) {
                    for (var n = arguments.length, r = new Array(n > 1 ? n - 1 : 0), o = 1; o < n; o++) r[o - 1] = arguments[o];
                    return r.length >= t.length ? t.apply(void 0, r) : e.bind.apply(e, [je, t].concat(r));
                },
                Oe = Me(function (e, t) {
                    return Array.isArray(t) ? t.map(e) : e(t);
                }),
                Le =
                    (Me(function (e, t) {
                        return Array.isArray(t) ? t.filter(e) : e(t) ? t : void 0;
                    }),
                    function (e) {
                        for (var t = arguments.length, n = new Array(t > 1 ? t - 1 : 0), r = 1; r < t; r++) n[r - 1] = arguments[r];
                        return e.bind.apply(e, [je].concat(n));
                    }),
                De = function () {
                    for (var e = arguments.length, t = new Array(e), n = 0; n < e; n++) t[n] = arguments[n];
                    return function (e) {
                        var n = this;
                        return t.reduce(function (e, t) {
                            return t.apply(n, [e]);
                        }, e);
                    };
                },
                He = Me(function (e, t) {
                    return t[e];
                }),
                Ie =
                    (Me(function (e, t) {
                        return t < e;
                    }),
                    Me(function (e, t, n) {
                        return (n[e] = t), n;
                    }),
                    Me(function (e, t, n, r) {
                        return r.reduce(function (e, r) {
                            return (
                                setTimeout(function () {
                                    return n(r);
                                }, e),
                                e + t
                            );
                        }, e);
                    }),
                    function e(t, n, r) {
                        return t(r) ? e(t, n, n(r)) : r;
                    }),
                Ue =
                    (Me(function (e, t) {
                        return t / e;
                    }),
                    Me(function (e, t) {
                        return t * e;
                    }),
                    Me(function (e, t) {
                        return -1 !== e.indexOf(t);
                    }),
                    Me(function (e, t) {
                        return e < 0 ? t[t.length + e] : t[e];
                    })),
                Fe = (Ue(1), Ue(-1)),
                We = Me(function (e, t) {
                    return t + e;
                }),
                Be =
                    (De(Fe, We(1)),
                    function (e) {
                        return Array.prototype.slice.call(e);
                    });
            Me(function (e, t) {
                return t.then(e);
            }),
                Me(function (e, t) {
                    return t.catch(e);
                });
            var Re = Me(function (e, t) {
                    return Oe(function (t) {
                        return t.classList.add(e), t;
                    }, t);
                }),
                $e =
                    (Me(function (e, t) {
                        return Oe(function (t) {
                            return e.appendChild(t);
                        }, t);
                    }),
                    Me(function (e, t, n) {
                        return (n.style[e] = t), n;
                    })),
                Ve =
                    ($e("display", "none"),
                    Me(function (e, t) {
                        return getComputedStyle(t)[e];
                    }),
                    He("clientHeight"),
                    Me(function (e, t) {
                        return t.classList.contains(e);
                    }),
                    function (e, t) {
                        return t.getAttribute(e);
                    }),
                qe =
                    (Me(Ve),
                    Me(function (e, t, n) {
                        return n.setAttribute(e, t), n;
                    })),
                ze =
                    (Me(function (e, t) {
                        t.removeAttribute(e);
                    }),
                    Me(function (e, t) {
                        return Ve("data-" + e, t);
                    }),
                    Me(function (e, t, n) {
                        return qe("data-" + e, t, n);
                    }),
                    function (e, t, n, r) {
                        return r.addEventListener(e, t, n), r;
                    }),
                Ge = function (e, t, n, r) {
                    return r.removeEventListener(e, t, n), r;
                },
                Ye = function (e, t) {
                    for (var n = 0, r = ["matches", "matchesSelector", "mozMatchesSelector", "msMatchesSelector", "oMatchesSelector", "webkitMatchesSelector"]; n < r.length; n++) {
                        var o = r[n];
                        if ("function" == typeof t[o]) return t[o](e);
                    }
                    return !1;
                },
                Je = Me(function (e, t, n) {
                    return Oe(Le(ze, e, t, {}), n);
                }),
                Xe =
                    (Me(function (e, t, n) {
                        return Oe(Le(Ge, e, t, {}), n);
                    }),
                    Me(function (e, t, n) {
                        return Oe(Le(ze, e, t, { passive: !0 }), n);
                    }),
                    Me(function (e, t, n) {
                        return Oe(Le(ze, e, t, !0), n);
                    }),
                    Me(function (e, t) {
                        return Ie(
                            function (t) {
                                return t && !Ye(e, t) && t.parentNode;
                            },
                            function (e) {
                                return e.parentNode === document ? null : e.parentNode;
                            },
                            t.parentNode
                        );
                    }),
                    function (e, t, n, r) {
                        return ze(
                            e,
                            function (e) {
                                var o = Ie(
                                    function (e) {
                                        return e && e !== document && !Ye(n, e) && e.parentNode;
                                    },
                                    function (e) {
                                        return e.parentNode;
                                    },
                                    e.target
                                );
                                o !== document && Ye(n, o) && t.apply(r, [e]);
                            },
                            {},
                            r
                        );
                    }),
                Ke =
                    (Me(function (e, t, n, r) {
                        return Oe(Le(Xe, e, t, n), r);
                    }),
                    Me(function (e, t) {
                        return Oe(function (t) {
                            return t.classList.remove(e), t;
                        }, t);
                    })),
                Qe =
                    (Me(function (e, t) {
                        return Oe(function (t) {
                            return t.classList.toggle(e), t;
                        }, t);
                    }),
                    function (e) {
                        return (arguments.length > 1 && void 0 !== arguments[1] ? arguments[1] : document).querySelector(e);
                    }),
                Ze = function (e) {
                    var t = arguments.length > 1 && void 0 !== arguments[1] ? arguments[1] : document;
                    return Be(t.querySelectorAll(e));
                },
                et =
                    (De(He("children"), Be),
                    He("parentNode"),
                    He("offsetTop"),
                    He("value"),
                    "undefined" != typeof window && window.navigator && window.navigator.platform && (/iPad|iPhone|iPod/.test(window.navigator.platform) || ("MacIntel" === navigator.platform && navigator.maxTouchPoints)),
                    function (e) {
                        return e
                            .toLowerCase()
                            .replace(/[^\w\u00C0-\u024f]+/g, "-")
                            .replace(/^-+|-+$/g, "")
                            .normalize("NFD")
                            .replace(/[\u0300-\u036f]/g, "");
                    });
            var tt = !1;
            if ("undefined" != typeof window) {
                var nt = {
                    get passive() {
                        tt = !0;
                    },
                };
                window.addEventListener("testPassive", null, nt), window.removeEventListener("testPassive", null, nt);
            }
            var rt = "undefined" != typeof window && window.navigator && window.navigator.platform && (/iP(ad|hone|od)/.test(window.navigator.platform) || ("MacIntel" === window.navigator.platform && window.navigator.maxTouchPoints > 1)),
                ot = [],
                it = !1,
                ut = -1,
                lt = void 0,
                ct = void 0,
                at = function (e) {
                    return ot.some(function (t) {
                        return !(!t.options.allowTouchMove || !t.options.allowTouchMove(e));
                    });
                },
                st = function (e) {
                    var t = e || window.event;
                    return !!at(t.target) || t.touches.length > 1 || (t.preventDefault && t.preventDefault(), !1);
                },
                _t = function () {
                    void 0 !== ct && ((document.body.style.paddingRight = ct), (ct = void 0)), void 0 !== lt && ((document.body.style.overflow = lt), (lt = void 0));
                },
                ft = function (e, t) {
                    if (e) {
                        if (
                            !ot.some(function (t) {
                                return t.targetElement === e;
                            })
                        ) {
                            var n = { targetElement: e, options: t || {} };
                            (ot = [].concat(
                                (function (e) {
                                    if (Array.isArray(e)) {
                                        for (var t = 0, n = Array(e.length); t < e.length; t++) n[t] = e[t];
                                        return n;
                                    }
                                    return Array.from(e);
                                })(ot),
                                [n]
                            )),
                                rt
                                    ? ((e.ontouchstart = function (e) {
                                          1 === e.targetTouches.length && (ut = e.targetTouches[0].clientY);
                                      }),
                                      (e.ontouchmove = function (t) {
                                          1 === t.targetTouches.length &&
                                              (function (e, t) {
                                                  var n = e.targetTouches[0].clientY - ut;
                                                  !at(e.target) &&
                                                      ((t && 0 === t.scrollTop && n > 0) ||
                                                      ((function (e) {
                                                          return !!e && e.scrollHeight - e.scrollTop <= e.clientHeight;
                                                      })(t) &&
                                                          n < 0)
                                                          ? st(e)
                                                          : e.stopPropagation());
                                              })(t, e);
                                      }),
                                      it || (document.addEventListener("touchmove", st, tt ? { passive: !1 } : void 0), (it = !0)))
                                    : (function (e) {
                                          if (void 0 === ct) {
                                              var t = !!e && !0 === e.reserveScrollBarGap,
                                                  n = window.innerWidth - document.documentElement.clientWidth;
                                              t && n > 0 && ((ct = document.body.style.paddingRight), (document.body.style.paddingRight = n + "px"));
                                          }
                                          void 0 === lt && ((lt = document.body.style.overflow), (document.body.style.overflow = "hidden"));
                                      })(t);
                        }
                    } else console.error("disableBodyScroll unsuccessful - targetElement must be provided when calling disableBodyScroll on IOS devices.");
                },
                dt = function () {
                    rt
                        ? (ot.forEach(function (e) {
                              (e.targetElement.ontouchstart = null), (e.targetElement.ontouchmove = null);
                          }),
                          it && (document.removeEventListener("touchmove", st, tt ? { passive: !1 } : void 0), (it = !1)),
                          (ut = -1))
                        : _t(),
                        (ot = []);
                },
                vt = 1200,
                pt = function () {
                    var e = arguments.length > 0 && void 0 !== arguments[0] ? arguments[0] : "",
                        t = arguments.length > 1 && void 0 !== arguments[1] ? arguments[1] : window.innerWidth;
                    switch (e) {
                        case "desktop":
                            return t >= vt;
                        case "tablet":
                            return t >= 768 && t < 1024;
                        default:
                            return t < 1024;
                    }
                },
                ht = n(5858),
                mt = n.n(ht);
            const yt = function () {
                var e = l(me(pt("")), 2),
                    t = e[0],
                    n = e[1],
                    r = l(me(pt("tablet")), 2),
                    o = r[0],
                    i = r[1],
                    u = l(me(pt("desktop")), 2),
                    c = u[0],
                    a = u[1];
                return (
                    ye(function () {
                        Je(
                            "resize",
                            mt()(function () {
                                return (e = window.innerWidth), n(pt("", e)), i(pt("tablet", e)), void a(pt("desktop", e));
                                var e;
                            }, 500),
                            window
                        );
                    }, []),
                    { isMobile: t, isTablet: o, isDesktop: c }
                );
            };
            var gt = 0;
            Array.isArray;
            function bt(e, t, n, r, o, i) {
                t || (t = {});
                var u,
                    l,
                    c = t;
                if ("ref" in c) for (l in ((c = {}), t)) "ref" == l ? (u = t[l]) : (c[l] = t[l]);
                var s = { type: e, props: c, key: n, ref: u, __k: null, __: null, __b: 0, __e: null, __d: void 0, __c: null, constructor: void 0, __v: --gt, __i: -1, __u: 0, __source: o, __self: i };
                if ("function" == typeof e && (u = e.defaultProps)) for (l in u) void 0 === c[l] && (c[l] = u[l]);
                return a.vnode && a.vnode(s), s;
            }
            const wt = function (e) {
                return bt("svg", {
                    xmlns: "http://www.w3.org/2000/svg",
                    className: e.className ? "icon ".concat(e.className) : "icon",
                    viewBox: e.viewBox,
                    fill: "none",
                    children: bt("use", { xmlnsXlink: "http://www.w3.org/1999/xlink", xlinkHref: "#".concat(e.name), x: "0", y: "0" }),
                });
            };
            var xt = n(5072),
                kt = n.n(xt),
                Nt = n(7825),
                Ct = n.n(Nt),
                Tt = n(7659),
                Et = n.n(Tt),
                St = n(5056),
                At = n.n(St),
                Pt = n(540),
                jt = n.n(Pt),
                Mt = n(1113),
                Ot = n.n(Mt),
                Lt = n(171),
                Dt = n.n(Lt),
                Ht = {};
            (Ht.styleTagTransform = Ot()), (Ht.setAttributes = At()), (Ht.insert = Et().bind(null, "head")), (Ht.domAPI = Ct()), (Ht.insertStyleElement = jt());
            kt()(Dt(), Ht);
            Dt() && Dt().locals && Dt().locals;
            function It(e, t) {
                var n = Object.keys(e);
                if (Object.getOwnPropertySymbols) {
                    var r = Object.getOwnPropertySymbols(e);
                    t &&
                        (r = r.filter(function (t) {
                            return Object.getOwnPropertyDescriptor(e, t).enumerable;
                        })),
                        n.push.apply(n, r);
                }
                return n;
            }
            function Ut(e) {
                for (var t = 1; t < arguments.length; t++) {
                    var n = null != arguments[t] ? arguments[t] : {};
                    t % 2
                        ? It(Object(n), !0).forEach(function (t) {
                              u(e, t, n[t]);
                          })
                        : Object.getOwnPropertyDescriptors
                        ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(n))
                        : It(Object(n)).forEach(function (t) {
                              Object.defineProperty(e, t, Object.getOwnPropertyDescriptor(n, t));
                          });
                }
                return e;
            }
            var Ft = { activeClass: "active", menuTriggerClass: ".js-menu-trigger", menuItemClass: ".js-menu-item", subActive: "active-sub", megaMenuInner: ".mega-menu-inner", delayTime: 300 };
            function Wt(e) {
                var t = e.settings,
                    n = e.item,
                    r = null == t ? void 0 : t.type["level".concat(n.level)];
                return 0 === (null == n ? void 0 : n.children.length)
                    ? bt("a", { className: "menu-sub-title", href: n.url, children: n.title })
                    : (function (e) {
                          switch (r) {
                              case "panel":
                              default:
                                  return bt(Rt, { settings: t, item: e });
                              case "accordion":
                                  return bt($t, { settings: t, item: e });
                          }
                      })(n);
            }
            function Bt() {
                for (var e = arguments.length > 0 && void 0 !== arguments[0] ? arguments[0] : 1; e < 3; ) {
                    var t = Ze('.js-menu-sub-panel[data-level="'.concat(e, '"]'));
                    Ze('.js-button-open-sub-menu[data-level="'.concat(e, '"]')).forEach(function (e) {
                        return e && e.classList.remove(Ft.subActive);
                    }),
                        t.forEach(function (e) {
                            return e && e.classList.remove(Ft.activeClass);
                        }),
                        e++;
                }
                dt();
            }
            function Rt(e) {
                var t = e.settings,
                    n = e.item,
                    o = ge(null),
                    i = ge(null),
                    u = function (e) {
                        e.preventDefault();
                        var t = o.current.classList.contains(Ft.activeClass);
                        if ((Bt(n.level), t)) {
                            if ((Ke(Ft.activeClass, o.current), Ke(Ft.subActive, e.target), dt(), 1 === n.level)) {
                                var u = Qe(Ft.megaMenuInner);
                                ft(u);
                            } else if (n.level > 1) {
                                var l = n.level - 1,
                                    c = Ze(".menu-sub-panel-inner-" + l);
                                console.log(c), Oe(ft, r(c));
                            }
                        } else Re(Ft.activeClass, o.current), Re(Ft.subActive, e.target), ft(i.current);
                    };
                return bt(T, {
                    children: [
                        bt("a", {
                            className: "menu-sub-title js-button-open-sub-menu",
                            "data-level": n.level,
                          href: n.url,
                            children: [n.title, bt(wt, { viewBox: "0 0 20 20", name: "icon-chevron-forward-outline-thin", className: "flex-shrink-0 w-5 h-5 text-primary" })],
                        }),
                        bt("div", {
                            ref: o,
                            className: "menu-sub-panel menu-sub-panel-".concat(n.level, " js-menu-sub-panel"),
                            "data-level": n.level,
                            children: bt("div", {
                                className: "container menu-sub-panel-container",
                                children: bt("div", {
                                    ref: i,
                                    className: "menu-sub-panel-inner menu-sub-panel-inner-".concat(n.level, " ").concat(n.children.length > 8 ? "scrollbar-custom-wrapper" : "lg:!h-fit"),
                                    children: [
                                        bt("div", {
                                            className: "menu-sub-panel-heading",
                                            children: [
                                                bt("button", {
                                                    className: "menu-sub-panel-back",
                                                    onclick: u,
                                                    children: bt(wt, { viewBox: "0 0 20 20", name: "icon-chevron-forward-outline-thin", className: "w-5 h-5 rotate-180 text-primary" }),
                                                }),
                                                bt("div", { className: "menu-sub-panel-title", children: n.title }),
                                            ],
                                        }),
                                        bt("div", {
                                            className: "menu-sub-panel-content ".concat(n.children.length > 8 ? "scrollbar-custom" : ""),
                                            children: bt("div", {
                                                className: "menu-sub-panel-content-inner ".concat(n.children.length > 8 ? " scrollbar-custom-inner" : ""),
                                                children: [
                                                    (null == n ? void 0 : n.countCollection) &&
                                                        bt("a", {
                                                            className: "menu-sub-title menu-sub-title-view-all",
                                                            href: n.url,
                                                            children: [
                                                                "View All ",
                                                                n.title,
                                                                bt("span", {
                                                                    children: [bt("span", { className: "lg:hidden ml-0.5", children: "(" }), null == n ? void 0 : n.countCollection, bt("span", { className: "lg:hidden", children: ")" })],
                                                                }),
                                                            ],
                                                        }),
                                                    null == n
                                                        ? void 0
                                                        : n.children.map(function (e, n) {
                                                              return bt(Wt, { settings: t, item: e }, n);
                                                          }),
                                                ],
                                            }),
                                        }),
                                    ],
                                }),
                            }),
                        }),
                    ],
                });
            }
            function $t(e) {
                e.settings;
                return bt(T, { children: [bt("a", { className: "menu-sub-title", children: e.item.title, href:e.url }), bt("div", { className: "", children: "MenuSubAccordion" })] });
            }
            function Vt() {
                var e,
                    t,
                    n,
                    r =
                        null === (e = menuData) || void 0 === e
                            ? void 0
                            : e.secondMenu.map(function (e) {
                                  var t = e.title.split("] ");
                                  return { iconName: t[0].replace("[", ""), title: t[1], url: e.url };
                              });
                return (
                    (null === (t = menuData) || void 0 === t ? void 0 : t.secondMenu) &&
                    (null === (n = menuData) || void 0 === n ? void 0 : n.secondMenu.length) > 0 &&
                    bt("div", {
                        className: "px-5 py-6 mt-auto bg-grey-100 lg:hidden",
                        children: r.map(function (e) {
                            return bt("a", { className: "flex items-center mb-4 text-sm text-grey-900 last:mb-0", children: [bt(wt, { viewBox: "0 0 21 20", name: e.iconName, className: "w-5 h-5 mr-3 text-secondary" }), e.title] });
                        }),
                    })
                );
            }
            !(function (e, t, n, r) {
                function o() {
                    var t = Reflect.construct(HTMLElement, [], o);
                    return (t._vdomComponent = e), (t._root = r && r.shadow ? t.attachShadow({ mode: r.mode || "open" }) : t), t;
                }
                ((o.prototype = Object.create(HTMLElement.prototype)).constructor = o),
                    (o.prototype.connectedCallback = K),
                    (o.prototype.attributeChangedCallback = Z),
                    (o.prototype.disconnectedCallback = ee),
                    (n = n || e.observedAttributes || Object.keys(e.propTypes || {})),
                    (o.observedAttributes = n),
                    n.forEach(function (e) {
                        Object.defineProperty(o.prototype, e, {
                            get: function () {
                                return this._vdom.props[e];
                            },
                            set: function (t) {
                                this._vdom ? this.attributeChangedCallback(e, null, t) : (this._props || (this._props = {}), (this._props[e] = t), this.connectedCallback());
                                var n = typeof t;
                                (null != t && "string" !== n && "boolean" !== n && "number" !== n) || this.setAttribute(e, t);
                            },
                        });
                    }),
                    customElements.define(t || e.tagName || e.displayName || e.name, o);
            })(function () {
                var e,
                    t,
                    n,
                    o,
                    i,
                    u,
                    c,
                    a,
                    s,
                    _ = ge(null),
                    f = ge(null),
                    d = l(me([]), 2),
                    v = d[0],
                    p = d[1],
                    h = l(me([]), 2),
                    m = h[0],
                    y = h[1],
                    g = l(me(!1), 2),
                    b = g[0],
                    w = g[1],
                    x = l(me(0), 2),
                    k = x[0],
                    N = x[1],
                    C = yt().isMobile,
                    T = Ze(Ft.menuItemClass),
                    E = function () {
                        _.current && (Bt(), Ke(Ft.activeClass, _.current), dt());
                    },
                    S = function () {
                        _.current && (Re(Ft.activeClass, _.current), ft(f.current));
                    },
                    A = function () {
                        Ze(Ft.menuTriggerClass).forEach(function (e) {
                            e.addEventListener("click", S);
                        }),
                            !C &&
                                _.current &&
                                (Je(
                                    "mouseenter",
                                    function (e) {
                                        w(!0);
                                    },
                                    _.current
                                ),
                                Je(
                                    "mouseleave",
                                    function (e) {
                                        w(!1);
                                    },
                                    _.current
                                ));
                    },
                    P = function () {
                        b ? S() : E();
                    };
                return (
                    ye(function () {
                        var e, t, n, o, i, u;
                        (o =
                            null === (e = menuData) || void 0 === e
                                ? void 0
                                : e.mainMenu.children.map(function (e) {
                                      var t;
                                      return Ut(
                                          Ut({}, e),
                                          {},
                                          {
                                              children: [].concat(
                                                  r(e.children),
                                                  r(
                                                      (null === (t = menuData) ||
                                                      void 0 === t ||
                                                      null ===
                                                          (t = t.blocks.find(function (t) {
                                                              return et(t.title) === et(e.title);
                                                          })) ||
                                                      void 0 === t
                                                          ? void 0
                                                          : t.menu) || []
                                                  )
                                              ),
                                          }
                                      );
                                  })),
                            (i = Ut(Ut({}, null === (t = menuData) || void 0 === t ? void 0 : t.mainMenu), {}, { children: o })),
                            (u =
                                null !== (n = menuData) && void 0 !== n && n.settings.hideLevel1
                                    ? i.children.find(function (e) {
                                          return e.children.length > 0;
                                      })
                                    : i),
                            p(u),
                            y(i);
                    }, []),
                    ye(
                        function () {
                            var e;
                            A(),
                                C ||
                                    void 0 === (null == m || null === (e = m.children) || void 0 === e ? void 0 : e.length) ||
                                    null == m ||
                                    m.children.forEach(function (e) {
                                        if ((null == e ? void 0 : e.children.length) > 0) {
                                            var t = Qe('.js-menu-item[data-title="'.concat(et(e.title), '"]'));
                                            Je(
                                                "mouseenter",
                                                function (n) {
                                                    Ke(Ft.activeClass, T), Re(Ft.activeClass, t), p(e), w(!0), N(n.target.getBoundingClientRect().left);
                                                },
                                                t
                                            ),
                                                Je(
                                                    "mouseleave",
                                                    function (e) {
                                                        w(!1);
                                                    },
                                                    t
                                                );
                                                t.addEventListener("click", function () {
                                if (e.url) {
                                    window.location.href = e.url; 
                                }
                            });
                                        }
                                    });
                        },
                        [m]
                    ),
                    ye(
                        function () {
                            b && Ke(Ft.activeClass, T);
                            var e = setTimeout(P, Ft.delayTime);
                            return function () {
                                clearTimeout(e);
                            };
                        },
                        [b]
                    ),
                    (null == v || null === (e = v.children) || void 0 === e ? void 0 : e.length) > 0 &&
                        bt("div", {
                            ref: _,
                            className: "mega-menu",
                            style: "--position-left: ".concat(k, "px"),
                            children: [
                                bt("div", { className: "mega-menu-overlay", onclick: E }),
                                bt("button", {
                                    onclick: E,
                                    "aria-label": "Close Mega Menu",
                                    className: "absolute right-[328px] z-50 top-2 hidden [.active_&]:block lg:[.active_&]:hidden",
                                    children: bt(wt, { name: "icon-close-circle-outline", viewBox: "0 0 40 40", className: "w-10 h-10 text-white" }),
                                }),
                                bt("div", {
                                    className: "container mega-menu-container",
                                    children: bt("div", {
                                        ref: f,
                                        className: "mega-menu-inner ".concat((null == v || null === (t = v.children) || void 0 === t ? void 0 : t.length) > 8 ? "scrollbar-custom-wrapper" : "lg:!h-fit"),
                                        children: [
                                            (null === (n = menuData) || void 0 === n || null === (n = n.settings) || void 0 === n ? void 0 : n.ctaText) &&
                                                (null === (o = menuData) || void 0 === o || null === (o = o.settings) || void 0 === o ? void 0 : o.ctaLink) &&
                                                bt("a", {
                                                    href: null === (i = menuData) || void 0 === i || null === (i = i.settings) || void 0 === i ? void 0 : i.ctaLink,
                                                    className: "mx-5 mt-5 text-sm font-bold button-primary flex-center font-body lg:hidden",
                                                    children: [
                                                        bt(wt, { name: "icon-login", viewBox: "0 0 20 20", className: "w-5 h-5 mr-2 text-accent-1" }),
                                                        null === (u = menuData) || void 0 === u || null === (u = u.settings) || void 0 === u ? void 0 : u.ctaText,
                                                    ],
                                                }),
                                            bt("div", {
                                                className: "w-full h-full bg-white lg-max:my-6 ".concat((null == v || null === (c = v.children) || void 0 === c ? void 0 : c.length) > 8 ? "scrollbar-custom" : ""),
                                                children: bt("div", {
                                                    className: "w-full h-full  ".concat((null == v || null === (a = v.children) || void 0 === a ? void 0 : a.length) > 8 ? "scrollbar-custom-inner" : ""),
                                                    children:
                                                        null == v || null === (s = v.children) || void 0 === s
                                                            ? void 0
                                                            : s.map(function (e, t) {
                                                                  var n;
                                                                  return e && bt(Wt, { settings: null === (n = menuData) || void 0 === n ? void 0 : n.settings, item: e }, t);
                                                              }),
                                                }),
                                            }),
                                            bt(Vt, {}),
                                        ],
                                    }),
                                }),
                            ],
                        })
                );
            }, "mega-menu");
        })();
})();
